import { render } from "./administrationheadertab.vue?vue&type=template&id=0f592e49&scoped=true"
import script from "./administrationheadertab.vue?vue&type=script&lang=js"
export * from "./administrationheadertab.vue?vue&type=script&lang=js"

import "./administrationheadertab.vue?vue&type=style&index=0&id=0f592e49&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f592e49"]])

export default __exports__